import { render, staticRenderFns } from "./MarketingEmailCreateVerify.vue?vue&type=template&id=65697086&scoped=true"
import script from "./MarketingEmailCreateVerify.vue?vue&type=script&lang=js"
export * from "./MarketingEmailCreateVerify.vue?vue&type=script&lang=js"
import style0 from "./MarketingEmailCreateVerify.vue?vue&type=style&index=0&id=65697086&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65697086",
  null
  
)

export default component.exports